export interface CarItem {
  id: number;
  model: string;
  seats: number;
  transmission: string;
  tags: string[];
  price: number;
  image: string;
}

export const carList: CarItem[] = [
  {
    id: 1,
    model: "别克 GL8 商务7座",
    seats: 7,
    transmission: "自动",
    tags: ["含司机", "全险", "免押金"],
    price: 900,
    image: "https://readdy.ai/api/search-image?query=Buick%20GL8%20MPV%20white%20luxury%20business%20van%20side%20view%20clean%20simple%20light%20background%20automotive%20photography%20professional&width=200&height=130&seq=601&orientation=landscape",
  },
  {
    id: 2,
    model: "丰田 塞纳 豪华7座",
    seats: 7,
    transmission: "自动",
    tags: ["含司机", "全险", "免押金"],
    price: 1100,
    image: "https://readdy.ai/api/search-image?query=Toyota%20Sienna%20white%20MPV%20luxury%20minivan%20side%20view%20clean%20light%20background%20professional%20automotive%20photography&width=200&height=130&seq=602&orientation=landscape",
  },
  {
    id: 3,
    model: "大众 途昂 5座SUV",
    seats: 5,
    transmission: "自动",
    tags: ["自驾", "全险", "免押金"],
    price: 480,
    image: "https://readdy.ai/api/search-image?query=VW%20Touareg%20white%20SUV%20front%20side%20view%20clean%20background%20professional%20car%20photography%20modern%20elegant&width=200&height=130&seq=603&orientation=landscape",
  },
  {
    id: 4,
    model: "奔驰 V260 豪华商务",
    seats: 7,
    transmission: "自动",
    tags: ["含司机", "奢华内饰", "全险"],
    price: 1580,
    image: "https://readdy.ai/api/search-image?query=Mercedes%20V%20Class%20V260%20luxury%20business%20van%20black%20silver%20side%20view%20clean%20background%20premium%20automotive%20photography&width=200&height=130&seq=604&orientation=landscape",
  },
];

export const guideList = [
  {
    id: 1,
    name: "陈美玲",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20tour%20guide%20portrait%20smiling%20confidently%20uniform%20tropical%20background%20headshot%20photography%20warm%20light&width=80&height=80&seq=701&orientation=squarish",
    rating: 5.0,
    reviewCount: 423,
    language: "普通话 / 英语",
    serviceType: "全程陪同",
    experience: "8年",
    price: 580,
    tags: ["金牌导游", "亲子专线", "英语流利"],
  },
  {
    id: 2,
    name: "王志远",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20tour%20guide%20portrait%20smiling%20confident%20outdoor%20background%20headshot%20photography%20friendly%20expression&width=80&height=80&seq=702&orientation=squarish",
    rating: 4.9,
    reviewCount: 356,
    language: "普通话 / 粤语",
    serviceType: "半日游/全日游",
    experience: "6年",
    price: 480,
    tags: ["历史文化", "摄影达人"],
  },
  {
    id: 3,
    name: "李思琦",
    avatar: "https://readdy.ai/api/search-image?query=young%20professional%20female%20tour%20guide%20portrait%20warm%20smile%20outdoor%20natural%20light%20headshot%20photography%20travel%20service&width=80&height=80&seq=703&orientation=squarish",
    rating: 4.8,
    reviewCount: 289,
    language: "普通话 / 日语",
    serviceType: "全程陪同",
    experience: "5年",
    price: 520,
    tags: ["日语接待", "婚纱旅拍"],
  },
  {
    id: 4,
    name: "张明宇",
    avatar: "https://readdy.ai/api/search-image?query=experienced%20male%20tour%20guide%20portrait%20professional%20friendly%20smile%20tropical%20outdoor%20background%20headshot%20travel%20guide%20photography&width=80&height=80&seq=704&orientation=squarish",
    rating: 4.7,
    reviewCount: 198,
    language: "普通话",
    serviceType: "定制行程",
    experience: "10年",
    price: 680,
    tags: ["深度游", "美食推荐", "本地达人"],
  },
];

export const routeList = [
  {
    id: 1,
    name: "三亚5日经典游",
    summary: "蜈支洲岛 · 天涯海角 · 南山文化苑",
    days: 5,
    price: 2400,
    rating: 4.8,
    image: "https://readdy.ai/api/search-image?query=Sanya%20Wuzhizhou%20island%20classic%20tour%20crystal%20clear%20blue%20water%20tropical%20scenery%20bright%20sunny%20day%20travel%20photography&width=200&height=140&seq=801&orientation=landscape",
  },
  {
    id: 2,
    name: "亚特兰蒂斯+水世界2日游",
    summary: "海底隧道 · 水上乐园 · 丽世酒店",
    days: 2,
    price: 1600,
    rating: 4.9,
    image: "https://readdy.ai/api/search-image?query=Atlantis%20Sanya%20water%20park%20resort%20aerial%20view%20colorful%20water%20slides%20tropical%20setting%20luxury%20travel%20destination%20photography&width=200&height=140&seq=802&orientation=landscape",
  },
  {
    id: 3,
    name: "大小洞天+呀诺达雨林1日游",
    summary: "热带雨林 · 道教圣地 · 摩天岭",
    days: 1,
    price: 680,
    rating: 4.7,
    image: "https://readdy.ai/api/search-image?query=Yanoda%20rainforest%20Sanya%20tropical%20jungle%20tour%20lush%20green%20trees%20misty%20atmosphere%20adventure%20travel%20photography&width=200&height=140&seq=803&orientation=landscape",
  },
  {
    id: 4,
    name: "蜈支洲岛潜水浮潜体验",
    summary: "珊瑚礁潜水 · 水上运动 · 岛屿探索",
    days: 1,
    price: 580,
    rating: 4.9,
    image: "https://readdy.ai/api/search-image?query=Wuzhizhou%20island%20snorkeling%20diving%20coral%20reef%20crystal%20clear%20blue%20water%20tropical%20fish%20underwater%20photography%20adventure%20travel&width=200&height=140&seq=804&orientation=landscape",
  },
];
